const fiatSectionCopy = {
  addBank: 'Add Bank',
  errorMessageCreateCustodianFailed:
    'An error occured while attempting to add your new custodian. Please try again.',
  errorMessageCreateInstructionFailed:
    'An error occured while attempting to add your new instruction. Please try again.',
  errorMessageCreateManualAccountFailed:
    'An error occured while attempting to add your new account. Please try again.',
  errorMessageDeleteInstructionFailed:
    'An error occured while attempting to delete the selected instruction. Please try again.',
  errorMessageUpdateAccountFailed:
    'An error occured while attempting to update your account. Please try again.',
  errorMessageUpdateCustodianFailed:
    'An error occured while attempting to update your custodian. Please try again.',
  errorMessageUpdateInstructionFailed:
    'An error occured while attempting to update the selected instruction. Please try again.',
  nullCustodian: 'No Custodian',
  sectionTitle: 'Fiat',
  showAccountFormTabLabel: 'Add Account',
  successMessageCreateCustodian:
    'Your new custodian was successfully created.',
  successMessageCreateInstruction:
    'Your new instruction was successfully created.',
  successMessageCreateManualAccount:
    'Your new account was successfully created.',
  successMessageDeleteInstruction:
    'The selected instruction was successfully deleted.',
  successMessageUpdateAccount: 'Your account was successfully updated.',
  successMessageUpdateCustodian: 'Your custodian was successfully updated.',
  successMessageUpdateInstruction:
    'The selected instruction was successfully updated.'
};

export default fiatSectionCopy;
